import { redirectToLogin } from "../annoucement-sheet";
import { api } from "../api";
import authHeader from "../auth-header";
export interface ILeadershipInfo {
    "leadershipPage": ILeadership,
    "board_of_directors":ILeader,
    "executive_leadership":ILeader,
}
export interface ILeadership {
    "id": number,
    "sub_menu_id": number,
    "menu_id": number,
    "slug":string,
    "title_en": string,
    "title_tc": string,
    "title_sc": string,
    "meta_title_en": string,
    "meta_title_tc": string,
    "meta_title_sc": string,
    "meta_description_en": string,
    "meta_description_tc": string,
    "meta_description_sc": string,
    "meta_image": string,
    "banner_mobile_image": string,
    "banner_desktop_image": string,
}
export interface ILeader{
    "id": number,
    "page_id": number,
    "section_order": number,
    "unique_name": string,
    "sub_title_en": string,
    "sub_title_tc": string,
    "sub_title_sc": string,
    "title_en": string,
    "title_tc": string,
    "title_sc": string,
    "description_en": string,
    "description_tc": string,
    "description_sc": string,
    "image": string,
    "additional_data_en": any,
    "additional_data_tc": null,
    "additional_data_sc": null,
    "hide_director_image"?:boolean,
    "hide_executive_image"?:boolean,
}
export type TData = {
    data: [];
    total: number;
};
export type PaginationData = {
    page: number;
    limit: number | string | undefined;
    search: string | number;
    sort?: string;
    type?: string;
};
export const leadershipApi = api.injectEndpoints({
    endpoints: (build) => ({
        getLeaderShips: build.query<ILeadershipInfo, void>({
            query: () => ({
                url: `fetch-leadership-page`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "CompanyHistory" as const, id: "LIST" }]
        }),
        getLeaderShipLis: build.query<TData, PaginationData>({
            query: ({ limit, page, search,type,sort }) => ({
                url: `leadership-people-content?per_page=${limit}&page=${page}&search=${search}&type=${type}&sort=${sort}`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "Mission" as const, id: "LIST" }]
        }),
        getLeadershipInfo: build.mutation<TData, PaginationData>({
            query({ limit, page, search, type, sort }) {
                return {
                    headers: authHeader(),
                    url: `leadership-people-content?type=${type}&per_page=${limit}&page=${page}&search=${search}&sort=${sort}`,
                    method: "GET",
                };
            },
            invalidatesTags: ['Mission']
        }),
        deleteLeadership: build.mutation<TData, number>({
            query(body) {
                return {
                    headers: authHeader(),
                    url: `delete-leadership-people-content`,
                    body: {
                        id: body
                    },
                    method: "POST",
                };
            },
            invalidatesTags: ['Mission']
        }),
        getLeaderShipData: build.query<TData, PaginationData>({
            query: ({ limit, page, search, type,sort }) => ({
                url: `leadership-people-content?type=${type}&per_page=${limit}&page=${page}&search=${search}&sort=${sort}`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "Leadership" as const, id: "LIST" }]
        }),
        getExecutiveOfPeople: build.query<ILeadershipInfo, void>({
            query: () => ({
                url: `company-profile/leadership-team?section=board_people`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "Leadership" as const, id: "LIST" }]
        }),
    })
});

export const { useGetLeaderShipsQuery, useGetLeaderShipLisQuery, useGetLeadershipInfoMutation, useDeleteLeadershipMutation, useGetLeaderShipDataQuery } = leadershipApi;

export const {
    endpoints: { getLeaderShips, getLeaderShipLis, getLeadershipInfo, deleteLeadership, getLeaderShipData }
} = leadershipApi;
